


















import { Component, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Datagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import { DxNavBar, DxDataGrid } from 'devextreme-vue';
import { ArticleCategory, ArticleCategoryClient, CreateArticleCategoryCommand, DataSourceLoadOptions, IArticleCategory, UpdateArticleCategoryCommand } from '@/data/web-api-client';
import DataSource from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';

@Component({
  components: {
    Datagrid,
    DxNavBar,
  },
})
export default class ArticleCategoryTable extends Vue {
  public loading = false;
  public items: IArticleCategory[] = [];
  client = new ArticleCategoryClient(undefined, this.$axios);

  created() {
    this.loadData();
  }

  public async loadData() {
    try {
      this.loading = true;
    } catch {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  public datasource: DataSource = new DataSource({
    store: new dxCustomStore({
      key: 'id',
      load: async (loadOptions) => {
        (loadOptions as any).stringToLower = true;

        const result = await this.client.lookup(new DataSourceLoadOptions(loadOptions));

        return {
          data: result.data,
          totalCount: result.totalCount,
        };
      },
      remove: async (val: any) => {
        try {
          await this.client.deleteSingle(val);
          notificationService.saved();
        } catch (err) {
          notificationService.failedToSave();
        }
      },
      insert: async (val: any) => {
        try {
          try {
            this.validateOptimizationValues(val);
          } catch (err) {
            notificationService.showErrorMessage(err.message);

            return;
          }

          await this.client.create(
            new CreateArticleCategoryCommand({
              name: val.name,
              optimizationFrom: val.optimizationFrom,
              optimizationUntil: val.optimizationUntil,
              optimizationPercentage: val.optimizationPercentage,
              articleCategoryNumber: val.articleCategoryNumber,
            })
          );
          notificationService.saved();
        } catch (err) {
          notificationService.failedToSave();
        }
      },
      update: async (id: any) => {
        try {
          const row = this.gridInstance.getVisibleRows().find((r: any) => r.key == id);

          if (!row) {
            return;
          }

          const articleCategory = row.data as IArticleCategory;

          try {
            this.validateOptimizationValues(articleCategory);
          } catch (err) {
            notificationService.showErrorMessage(err.message);

            return;
          }

          await this.client.update(
            id,
            new UpdateArticleCategoryCommand({
              id: articleCategory.id,
              name: articleCategory.name,
              optimizationFrom: articleCategory.optimizationFrom,
              optimizationUntil: articleCategory.optimizationUntil,
              optimizationPercentage: articleCategory.optimizationPercentage,
              articleCategoryNumber: articleCategory.articleCategoryNumber,
            })
          );

          notificationService.saved();
        } catch (err) {
          notificationService.failedToSave();
        }
      },
    }),
    paginate: true,
  });

  validateRowUpdate(e: any) {
    const newRow = { ...e.oldData, ...e.newData };

    e.cancel = new Promise((resolve, reject) => {
      try {
        this.validateOptimizationValues(newRow);
        resolve(false);
      } catch (err) {
        notificationService.showErrorMessage(err.message);
        resolve(true);
      }
    });
  }

  validateRowInsert(e: any) {
    e.cancel = new Promise((resolve, reject) => {
      try {
        this.validateOptimizationValues(e.data);
        resolve(false);
      } catch (err) {
        notificationService.showErrorMessage(err.message);
        resolve(true);
      }
    });
  }

  refresh() {
    try {
      this.gridInstance.refresh();
    } catch {
      notificationService.showErrorMessage('Mislukt om de grid te refreshen!');
    }
  }

  public async deleteRow(e: any) {
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await this.client.deleteSingle(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  addArticleCategory() {
    this.gridInstance.addRow();
  }

  validateOptimizationValues(articleCategory: IArticleCategory) {
    if (!articleCategory.optimizationFrom || !articleCategory.optimizationUntil) {
      return;
    }

    if (articleCategory.optimizationFrom > articleCategory.optimizationUntil) {
      throw new Error(this.$t('objects.articles.OptimizationFromCannotBeGreaterThanOptimizationUntil') as string);
    }
  }

  get columns() {
    return [
      {
        dataField: 'articleCategoryNumber',
        calculateDisplayValue(value: ArticleCategory) {
          if (!value.articleCategoryNumber || value.articleCategoryNumber == '0.0.0') return null;

          let displayValue = value.articleCategoryNumber;

          while (displayValue.endsWith('.0')) {
            displayValue = displayValue.slice(0, -2);
          }

          return displayValue;
        },
        caption: 'Code',
      },
      {
        dataField: 'name',
        caption: 'Naam',
      },
      {
        dataField: 'optimizationFrom',
        caption: this.$t('objects.articles.OptimizationFrom'),
        dataType: 'number',
      },
      {
        dataField: 'optimizationUntil',
        caption: this.$t('objects.articles.OptimizationUntil'),
        dataType: 'number',
      },
      {
        dataField: 'optimizationPercentage',
        caption: this.$t('objects.articles.OptimizationPercentageLabourTime'),
        dataType: 'number',
      },
      {
        type: 'buttons',
        buttons: ['edit', 'delete'],
      },
    ];
  }

  get toolbarOptions() {
    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-plus',
          text: 'Toevoegen',
          stylingMode: 'outlined',
          type: 'success',
          onClick: this.addArticleCategory,
        },
      },
    ];
  }

  get gridInstance(): dxDataGrid {
    return ((this.$refs.grid as Vue).$refs.articleCategoriesGrid as any).instance;
  }
}
